/* import __COLOCATED_TEMPLATE__ from './range-filter.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type OptimizeSuggestionsService from 'embercom/services/optimize-suggestions-service';
import { tracked } from '@glimmer/tracking';

interface Signature {
  Args: {
    dateRange: string;
    onDateRangeChange: (value: string) => void;
  };
}

export default class RangeFilter extends Component<Signature> {
  @service declare optimizeSuggestionsService: OptimizeSuggestionsService;
  @tracked declare dateValue: string;

  get dateRangeLabel(): string {
    return this.dateRangeOptions.find((date) => date.value === this.args.dateRange)?.label ?? '';
  }

  get dateRangeOptions(): Array<{ value: string; label: string }> {
    return this.optimizeSuggestionsService.getSuggestionGenerationDates().map((date) => ({
      value: date.timestamp ?? '',
      label: date.label,
    }));
  }

  @action
  handleDateRangeChange(value: string): void {
    this.dateValue = value;
    this.args.onDateRangeChange(value);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::Filters::RangeFilter': typeof RangeFilter;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/filters/range-filter': typeof RangeFilter;
  }
}
